export default {
  checklist: (state) => state.checklist,
  incompleteChecklistCount: (state) => state.checklist.reduce((count, item) => item.isDone ? count : (count + 1), 0)
};
